
import { Options, Vue } from 'vue-class-component';
import { CourseProduct, Product } from "@/data/products";
import { RegionPaymentGateway } from "@/data/payment";
import RegionService from "@/services/RegionService";
import apiConfig from "@/config/api";
import WirePayment from "@/components/payment/gateways/WirePayment.vue";
import PayPalExpressPayment from "@/components/payment/gateways/PayPalExpressPayment.vue";
import Alert from "@/components/Alert.vue";

@Options({
    props: {
        product: {
            type: Object,
            required: true,
        },
        isCurrent: {
            type: Boolean,
            required: false,
            default: false,
        },
        validationErrors: {
            type: Object,
            required: false,
            default: {},
        },

        additionalOrderData: {
            type: Object,
            required: false,
            default: {},
        },
    },
    components: {
        Alert,
        PayPalExpressPayment,
        WirePayment
    },
    emits: [
        'success',
        /*'valid',
        'invalid',
        'data',*/
    ],
    /*emits: {
        success: (value: any) => value === null || typeof value === 'string' || Array.isArray(value),
    },*/
})
export default class StepPayment extends Vue {
    product!: Product|CourseProduct
    additionalOrderData!: Record<string, any>

    paymentGateways: RegionPaymentGateway[] = []

    gatewaySelection: number|null = null

    loading = false


    get unselected() {
        return this.gatewaySelection === null;
    }

    get selectedGateway(): RegionPaymentGateway|null {
        return this.gatewaySelection !== null ? this.paymentGateways[this.gatewaySelection] : null;
    }

    get activePaymentGateways(): RegionPaymentGateway[] {
        return this.paymentGateways.filter(gateway => gateway.active);
    }

    resetSelection() {
        this.gatewaySelection = null;
    }

    loadPaymentMethods() {
        if( !this.product || !this.product.region_id ) {
            return;
        }

        this.loading = true;
        return RegionService.getRegionPaymentGateways(this.product.region_id).then(result => {
            this.paymentGateways = result.data?.data;
        }).finally(() => this.loading = false);
    }

    handleSuccess(message?: string|string[]) {
        // console.warn('PAYMENT GATEWAY SUCCESS: ' + message);
        this.$emit('success', message);
    }

    get assetsBaseUrl() {
        return apiConfig.frontendAssetsUrl;
    }

    mounted() {
        this.$watch('product', () => {
            this.loadPaymentMethods();

            //this.regionStale = true;
            /*if( newRegionId ) {
                this.$nextTick(this.loadRegion);
            }*/
        }, { immediate: true });
    }
}
